export default {"src":"/_next/static/media/download-icon.3db4f6d2.svg","height":21,"width":21};